import { useSelector, useDispatch } from "react-redux";
// import { Component } from "react";
import { dolog, toggleMenu } from "./actions";

export function LoginOK() {
  const login = useSelector((state) => state.log_in);
  const dispatch = useDispatch();

  // console.log("Login Rdux", login);
  return (
    <>
      <button onClick={() => dispatch(dolog())}>Change login Status</button>
      <h> Current Login Status : {login ? "True" : "False"} </h>
    </>
  );
}

export function ToggleMenu() {
  const state = useSelector((state) => state.menu_vis);
  const dispatch = useDispatch();

  // console.log("menu toggle Rdux", state);
  return (
    <>
      <div id="sidenavburger" onClick={() => dispatch(toggleMenu())}>
        <span>
          <i className="material-icons">{state? "menu_open" : "menu"}</i>
        </span>
      </div>
    </>
  );
}
